import React, { memo, useEffect, useState } from 'react'
import LineChart from 'app/components/Charts/LineChart'
import Spinner from 'app/components/Spinner'
import { getAdvertisementsIndicators } from 'app/api/indicators'

const options = [
  {
    border: '#0f4c75',
    background: 'rgba(15, 76, 117, 0.8)',
    label: 'Semana atual',
    variable: 'advertisements_current'
  },
  {
    border: '#bbe1fa',
    background: 'rgba(189, 225, 250, 0.8)',
    label: 'Cinco semanas atrás',
    variable: 'advertisements_five_weeks_ago'
  }
]

const IndicatorsAdvertisements = ({ filter }) => {
  const [labels, setLabels] = useState([])
  const [datasets, setDatasets] = useState([])
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    if (Boolean(filter.startDate) && Boolean(filter.endDate)) {
      setLoading(true)
      getAdvertisementsIndicators(filter).then(response => {
        if (!response.data || !response.data.length) {
          return false
        }

        setLabels(
          response.data.map(dataset => {
            return 'Semana ' + dataset.week
          })
        )

        setDatasets(
          options.map(option => ({
            label: option.label,
            borderWidth: 1,
            borderColor: option.border,
            backgroundColor: option.background,
            data: response.data.map(data => data[option.variable])
          }))
        )

        setLoading(false)
      })
    }
  }, [filter])

  if (loading) {
    return <Spinner />
  }

  return (
    <LineChart
      id={'chart-bar-advertisements'}
      label={'Semana'}
      labels={labels}
      datasets={datasets}
    />
  )
}

export default memo(IndicatorsAdvertisements)
